import React, { memo } from 'react'
import { usePdfCanvasRenderer } from './hooks/usePdfCanvasRenderer'

export const PDFViewer = memo(({ pageInstance, scaleFactor, pageIndex, top, width, height }) => {
  const canvasRef = usePdfCanvasRenderer(pageInstance, scaleFactor)
  return (
    <div
      data-page-index={pageIndex}
      style={{
        left: '50%',
        width: width,
        height: height,
        background: 'white',
        position: 'absolute',
        transform: `translate(-50%,${top}px)`,
      }}
    >
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />
    </div>
  )
})
